import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Skeleton from "@mui/material/Skeleton";
import ReactPlayer from "react-player";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import { getVideos } from "firestoreService";

function YoutubeVideos() {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;

    const load = async () => {
      try {
        const result = await getVideos();
        // `res.data` was read off a result that is undefined whenever the
        // document is missing, which threw and blanked the whole home page.
        if (active) setVideos(Array.isArray(result?.data) ? result.data : []);
      } catch (error) {
        console.error("Could not load videos:", error);
      } finally {
        if (active) setLoading(false);
      }
    };

    load();
    return () => {
      active = false;
    };
  }, []);

  // A section with nothing in it should not leave a heading stranded above
  // empty space.
  if (!loading && videos.length === 0) return null;

  return (
    <MKBox component="section" py={{ xs: 5, md: 8 }}>
      <Container>
        <MKBox textAlign="center" mb={{ xs: 4, md: 6 }} mx="auto" maxWidth="640px">
          <MKTypography variant="h2" mb={1.5} sx={{ fontSize: { xs: "1.6rem", md: "2.25rem" } }}>
            Watch our classes
          </MKTypography>
          <MKTypography variant="body2" color="text">
            Lessons and highlights from the A1 Home Tutors channel.
          </MKTypography>
        </MKBox>

        <Grid container spacing={3}>
          {loading
            ? [0, 1, 2].map((key) => (
                <Grid item xs={12} md={6} lg={4} key={key}>
                  <Skeleton variant="rounded" sx={{ aspectRatio: "16 / 9", height: "auto" }} />
                </Grid>
              ))
            : videos.map((url) => (
                <Grid item xs={12} md={6} lg={4} key={url}>
                  <Card
                    sx={{
                      borderRadius: 3,
                      overflow: "hidden",
                      boxShadow: ({ boxShadows: { lg } }) => lg,
                    }}
                  >
                    <Box sx={{ position: "relative", pt: "56.25%", bgcolor: "#000" }}>
                      <ReactPlayer
                        url={url}
                        controls
                        width="100%"
                        height="100%"
                        style={{ position: "absolute", top: 0, left: 0 }}
                      />
                    </Box>
                  </Card>
                </Grid>
              ))}
        </Grid>
      </Container>
    </MKBox>
  );
}

export default YoutubeVideos;
